import { h, Fragment } from 'preact';
import CartBlock from '../cart/CartBlock';
import FranchiseInfoBlock from '../blocks/FranchiseInfoBlock';
import UserInformationReviewBlock from '../blocks/UserInformationReviewBlock';
import AppointmentDetailsList from '../appointments/AppointmentDetailsList';
import ShortLeadInfoBlock from '../blocks/ShortLeadInfoBlock';
import useFormStore from '../../store/useFormStore';

/**
 * Printable version of the confirmation page for browser printing
 */
export default function PrintableConfirmation() {
  const selectedEstimateType = useFormStore((state) => state.selectedEstimateType);
  const isShortLeadForm = selectedEstimateType === 'on_site_estimate_short';

  return (
    <div id="printable-confirmation" className="hidden print:block">
      {isShortLeadForm ? (
        <ShortLeadInfoBlock />
      ) : (
        <Fragment>
          <div className="grid grid-cols-2 gap-4">
            <AppointmentDetailsList />
          </div>
          <CartBlock />
        </Fragment>
      )}
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-6">
          Your Appointment Location & Information
        </h2>
        <UserInformationReviewBlock />
      </div>
      <FranchiseInfoBlock />
    </div>
  );
}
